import { Box, Typography } from "@mui/material";

const LevelBadge = ({ level }) => {

    const textColor = '#000000';
    const backgroundColor ='#EAEAEA';
    const label = level ? `LV${level}` : '';

    return (
        <Box
            sx={{
                borderRadius: '4px',
                px: 1.5,
                py: 0.25,
                bgcolor: backgroundColor,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}
        >
            <Typography variant="fw400s12c000000" sx={{color: textColor, lineHeight: '20px'}}>
                {label}
            </Typography>
        </Box>
    )
}

export default LevelBadge;
